import { defineField, defineType } from 'sanity'
import { GrDocumentImage } from 'react-icons/gr'

export default defineType({
  name: 'photoNavItem',
  title: 'Photo Nav Item',
  type: 'object',
  icon: GrDocumentImage,
  fields: [
    defineField({
      name: 'link',
      type: 'link',
      title: 'Link',
    }),
    defineField({
      name: 'photo',
      type: 'image',
      title: 'Photo',
      options: {
        hotspot: true,
      },
    }),
  ],
  preview: {
    select: {
      link: 'link',
      photo: 'photo',
    },
    prepare(selection) {
      const { link, photo: media } = selection
      const title = link?.title || 'New nav item...'
      return {
        title,
        subtitle: '',
        media,
      }
    },
  },
})